"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedrainsm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedrainsm` : '') + (description ? ` desc-brandedrainsm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedrainsm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedrainsm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.3 14.27a1.11 1.11 0 0 1-2.02-.94c.26-.56 2.42-2.58 2.42-2.58s-.14 2.96-.4 3.52Z",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.7 14.68a1.11 1.11 0 1 1-2.03-.94c.27-.56 2.42-2.57 2.42-2.57s-.13 2.95-.4 3.51Z",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.67 19.5a1.11 1.11 0 0 1-2.02-.95c.26-.56 2.42-2.57 2.42-2.57s-.14 2.95-.4 3.52Z",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.95 19.5a1.11 1.11 0 0 1-2.02-.95c.26-.56 2.42-2.57 2.42-2.57s-.14 2.95-.4 3.52Z",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.57 16.24a1.11 1.11 0 0 1-2.02-.94c.26-.56 2.42-2.57 2.42-2.57s-.14 2.95-.4 3.52Z",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.93 6.06c0-1.53-1.1-2.8-2.54-3.07a4.67 4.67 0 0 0-8.3-.62 3.58 3.58 0 0 0-5.53 1.92C1.77 3.83 0 5.05 0 6.69S1.72 9.54 3.53 9.1a2.8 2.8 0 0 0 4.56.3 4.98 4.98 0 0 0 8.85-.21c1.66-.07 3-1.44 3-3.12Z",
    fill: "#D4D4D4"
  }));
};
var _default = exports.default = brandedrainsm;